/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'./components/Button',
	'./components/ToggleButton',
	'./components/SubMenu',
	'./components/DropDown'
], function(React, PropTypes, UI_TOOLKIT, Button, ToggleButton, SubMenu, DropDown) {

	const CHILD_COMPONENTS = {
		'Button': Button,
		'NextView': Button,
		'ToggleButton': ToggleButton,
		'SubMenu': SubMenu,
		'DropDown': DropDown
	};
	const Toolbar = UI_TOOLKIT.Toolbar;
	class ReactToolbar extends React.Component {
		constructor(props){
			super(props);
			this.items = this.props.itemSpecs;
			this.orientation = this.props.orientation;

			const isToolbarEnabled = () => {
				if (typeof this.props.enabled !== 'undefined') {
					return this.props.enabled;
				} else {
					return (this.props.itemSpecs.length > 0) ? true : false;
				}
			};
			this.state = {
				enabled: isToolbarEnabled(),
				selectedSubMenu: null
			};
		}

		updateButton = () => {
			this.forceUpdate();
		}

		setSelectedSubMenu = (name)=>{
			this.setState({
				selectedSubMenu: name
			});
		}
		_getComponent(item, index) {
			const ChildComponent = CHILD_COMPONENTS[item.type];
			if (ChildComponent) {
				const icon = item.icon;
				const focus = false;
				if (this.props.toolbarOptions && this.props.toolbarOptions.textOnly && this.props.orientation === 'vertical') {
					item.className = 'toolbarItem textOnly';
				}

				return (
					<ChildComponent
						key={index}
						itemSpec={item}
						icon={icon}
						focus={focus}
						updateButton={this.updateButton}
						nextViewCb={this.props.nextViewCb}
						toolbarOptions={this.props.toolbarOptions}
						toolbar={this.props.toolbar}
						selectedSubMenu={this.state.selectedSubMenu}
						setSelectedSubMenu={this.setSelectedSubMenu}
					/>
				);
			}
		}

		render() {
			if (this.state.enabled) {
				let toolbarClasses;
				if (this.props.toolbarOptions && this.props.toolbarOptions.textOnly === true) {
					toolbarClasses = '';
				} else {
					toolbarClasses = 'toolbarIcon toolbarItem';
				}

				if (this.props.toolbarOptions && this.props.toolbarOptions.isTextEditorOnly) {
					toolbarClasses += ' textOnlyToolBar';
				}
				return (
					<div className="reactToolbar">
						<Toolbar className={toolbarClasses} orientation={this.orientation}>
							{this.items.map((value, index) => {
								return this._getComponent(value, index);
							})}
						</Toolbar>
					</div>
				);
			} else {
				return (null);
			}
		}
	}

	ReactToolbar.propTypes = {
		itemSpecs: PropTypes.array,
		orientation: PropTypes.string,
		nextViewCb: PropTypes.function,
		enabled: PropTypes.boolean,
		toolbarOptions: PropTypes.object,
		toolbar: PropTypes.object
	};

	return ReactToolbar;
});
